import React from 'react';
import {SvgIcon} from '@fiverr/fit';
import classNames from 'classnames';
import { getScoreText, getRatingsCount } from '../../utils';
import PropTypes from 'prop-types';
import RatingTooltip from './rating_tooltip';
import './style.scss';

const FULL_STAR = 'full_star';
const EMPTY_STAR = 'o_star';
const HALF_STAR = 'o_half_star';

const Rating = ({ score, recentScore, gigId, votes, recentRatingsCount, starSize, starCount, isPro, recentRatingsExp, isProExperience }) => {
    const scoreText = recentRatingsExp ? getScoreText(recentScore) : getScoreText(score),
        showArrow = false, // Will be implemented in a later experiment
        arrowDirection = score < recentScore ? 'fa-arrow-up' : 'fa-arrow-down',
        starsScoreNum = Math.round(parseFloat(scoreText) * 2) / 2,
        starAttrs = {
            icon: FULL_STAR,
            color: isProExperience ? 'pro' : 'yellow',
            width: starSize,
            height: starSize
        },
        stars = [],
        isNonRatedProSeller = score <= 0 && isPro,
        showScore = score > 0,
        showRatingTooltip = recentRatingsExp && !isProExperience;

    let votesText = `(${getRatingsCount(votes)})`;

    if (recentRatingsExp) {
        votesText = recentRatingsCount ? `(${getRatingsCount(recentRatingsCount)})` : null;
    }

    for (let star = 1; star <= starCount; star++) {
        if (starCount > 1) {
            if (star <= starsScoreNum) {
                starAttrs.icon = FULL_STAR;
            } else if (star > Math.round(starsScoreNum)) {
                starAttrs.icon = EMPTY_STAR;
            } else {
                starAttrs.icon = HALF_STAR;
            }
        }

        starAttrs.key = `gig-rating-${gigId}`;

        stars.push(<SvgIcon {...starAttrs}/>);
    }

    return (
        <span className={classNames('gig-rating', { 'with-arrow': showArrow })}>
            {stars}
            {isNonRatedProSeller && <strong>{isProExperience ? i18n.t('rating.be_the_first_to_rate_pro') : i18n.t('rating.be_the_first_to_rate')}</strong>}
            {showScore && (<span><strong>{scoreText}</strong>{showArrow ? <i className={classNames('fa', arrowDirection)}/> : ' '}{votesText}</span>)}
            {showRatingTooltip && <RatingTooltip score={score} ratingsCount={votes} recentScore={recentScore} recentRatingsCount={recentRatingsCount}/>}
        </span>
    );
};

Rating.propTypes = {
    score: PropTypes.number,
    votes: PropTypes.number,
    recentScore: PropTypes.number,
    gigId: PropTypes.number,
    starSize: PropTypes.number,
    starCount: PropTypes.number,
    isPro: PropTypes.bool,
    recentRatingsExp: PropTypes.bool,
    isProExperience: PropTypes.bool
};

export default Rating;



// WEBPACK FOOTER //
// ./src/shared/rating/index.js